import { useAppSelector } from '@app/store/store';

import { selectActiveEditSaveIndicator } from '../selector';

/**
 * Hook for accessing the comprehensive save state of the active advanced edit.
 *
 * @example
 * const { isSaving, isSaved, isFailed, hasUnsavedChanges } = useSaveState();
 * {isSaving && <Spinner />}
 * {isFailed && <ErrorIcon />}
 */
export const useSaveState = () => {
  return useAppSelector(selectActiveEditSaveIndicator);
};
